'use client';

import { FC } from 'react';
import { CardContent } from '@/_components';
import { AdminMessagesContentProps } from './AdminMessagesContent.types';
import { AdminChatHeader } from './components/AdminChatHeader';
import { AdminChatContent } from './components/AdminChatContent';

export const AdminMessagesContent: FC<AdminMessagesContentProps> = ({
  isPreview,
}) => {
  return (
    <CardContent isFullHeight={true}>
      <AdminChatHeader isPreview={isPreview} />
      <AdminChatContent isPreview={isPreview} />
    </CardContent>
  );
};
